import React from "react";

export type StatusChipTone = "accent" | "muted" | "warning" | "error";

const TONE_CLASS: Record<StatusChipTone, string> = {
  accent: "text-accent bg-accent-15",
  warning: "text-warning bg-warning-15",
  error: "text-error bg-error-15",
  muted: "text-fg-muted bg-bg-subtle",
};

export const StatusChip = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement> & { tone?: StatusChipTone }
>(({ tone = "muted", className = "", children, ...rest }, ref) => (
  <span
    ref={ref}
    // Badge's box (padding, border, size, line height), so the two line up in a row.
    className={`inline-flex shrink-0 items-center p-[var(--spacing-xs)] border border-transparent leading-none whitespace-nowrap text-[length:var(--font-size-xx-small)] font-mono cursor-[inherit] rounded-app ${TONE_CLASS[tone]} ${className}`}
    {...rest}
  >
    {children}
  </span>
));
StatusChip.displayName = "StatusChip";
